import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {},
    textarea: {
      resize: 'none',
      width: '100%',
      padding: theme.spacing(3),
      lineHeight: theme.spacing(3),
      borderRadius: theme.spacing(1),
      borderColor: '#AEAEAE',
      backgroundColor: '#FAFAFA',
      fontFamily: 'inherit',
      color: theme.palette.text.secondary,
    },
    container: {
      width: '100%',
      paddingBottom: theme.spacing(2),
    },
    footer: {
      display: 'flex',
      marginTop: theme.spacing(2),
      justifyContent: 'space-between',
    },
    input: {
      background: '#fafafa !important',
      '& .MuiInputBase-input': {
        background: '#fafafa !important',
      },
      '& .MuiInputBase-multiline': {
        background: '#fafafa !important',
      },
    },
  };
});

export default useStyles;
